import { FaQuestion, FaSwimmer } from "react-icons/fa";
import { IoTennisball } from "react-icons/io5";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Heading,
  HStack,
  Icon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Stack,
  Text,
  UnorderedList,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import _ from "lodash";

import {
  activitiesTermsURL,
  itemAgreement,
} from "../../../../components/agreements";
import { Col, Row } from "../../../../components/paljs";

// import { PeriodType } from '@bevy/sport-team-graphql-schema'

const EntriesPopover = (entries: any) => {
  return (
    <Popover>
      <PopoverTrigger>
        <Button size="xs"> Pełna lista</Button>
      </PopoverTrigger>
      <PopoverContent bg="#F0F0F0">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Pełna lista zajęć:</PopoverHeader>
        <PopoverBody style={{ overflow: "scroll", maxHeight: 200 }}>
          {" "}
          <UnorderedList>
            {_.map(entries, (entry, idx) => (
              <ListItem key={idx}>
                {_.replace(entry, "T", " ")}
                {/* fcuk */}
              </ListItem>
            ))}
          </UnorderedList>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

type CartItemRowProps = {
  label?: string;
  children: any;
};
export const CartItemRow = ({ label, children }: CartItemRowProps) => {
  return (
    <Row>
      <Col breakPoint={{ sm: 12, md: 4 }}>
        <Box mb={3}>
          <Heading size="sm">{label ? label : " "}</Heading>
        </Box>
      </Col>
      <Col breakPoint={{ sm: 12, md: 8 }}>
        {" "}
        <Box mb={3}>{children}</Box>
      </Col>
    </Row>
  );
};

const BundleDetails = (bundle: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isBigScreen] = useMediaQuery("(min-width: 1300px)");
  return (
    <>
      <Button size="xs" ml={isBigScreen ? 2 : 0} mr={2} onClick={onOpen}>
        {isBigScreen ? "Szczegóły" : <Icon as={FaQuestion} />}
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Szczegóły zajęć</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <CartItemRow label="Sport">{bundle.sport}</CartItemRow>
              <CartItemRow label="Miejsce">{bundle.location}</CartItemRow>
              <CartItemRow label="Rodzaj">{bundle.type}</CartItemRow>
              <CartItemRow label="Dni zajęć">
                {_.size(bundle.dayTimes) === 1 ? (
                  `${bundle.dayTimes[0].day}, ${bundle.dayTimes[0].time}`
                ) : (
                  <UnorderedList>
                    {_.map(bundle.dayTimes, ({ day, time }, idx) => (
                      <ListItem key={idx}>
                        {day}, {time}
                      </ListItem>
                    ))}
                  </UnorderedList>
                )}
              </CartItemRow>
              <CartItemRow label="Ilość zajęć">
                {_.size(bundle.entries)}{" "}
                {_.size(bundle.entries) > 0 && EntriesPopover(bundle.entries)}{" "}
              </CartItemRow>
              {/* <CartItemRow label="Cena jednostkowa">{bundle.unitPrice.value} zł</CartItemRow> */}
              <CartItemRow label="Suma całkowita">
                {bundle.price.value} zł
              </CartItemRow>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Zamknij
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

type OrderItemRowProps = {
  sport?: string;
  type?: string;
  price: string;
  location?: string;
  name?: string;
  bundle?: any;
  isEditable?: boolean;
  setItemConsent?: (bool: boolean) => void;
  itemConsent?: boolean;
  agreementUrl?: string;
  agreementName?: string;
};
export default ({
  sport,
  type,
  price,
  location,
  name,
  bundle,
  isEditable,
  setItemConsent,
  itemConsent,
  agreementUrl,
  agreementName,
}: OrderItemRowProps) => {
  const [isBigScreen] = useMediaQuery("(min-width: 1300px)");

  const showIcon = sport === "Pływanie" || sport === "Tenis";
  const isSwimming = sport === "Pływanie";

  let periodName = _.get(bundle, "period.name", "BŁAD");
  periodName = _.replace(periodName, "Semestr", "sem.");

  if (!isBigScreen) {
    periodName = _.replace(periodName, "2022/2023", "22/23");
  }

  const AdditionalInfo = () => {
    return (
      <Box my={2}>
        <Row className={isEditable ? "greyBg" : ""}>
          <Col
            breakPoint={{ sm: 12 }}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 8,
            }}
          >
            <Stack>
              <HStack>
                <Checkbox
                  isChecked={!!itemConsent}
                  isInvalid={!itemConsent}
                  onChange={() => {
                    setItemConsent && setItemConsent(!itemConsent);
                  }}
                  isDisabled={!isEditable}
                ></Checkbox>{" "}
                <Text fontSize="sm">
                  {itemAgreement(
                    agreementName || "",
                    agreementUrl || activitiesTermsURL
                  )}
                  <span style={{ color: "red" }}>*</span>
                </Text>
              </HStack>
              <div>
                <small style={{ fontSize: "0.6rem" }}>
                  {" "}
                  <span style={{ color: "red" }}>*</span> zgody i wybory
                  wymagane
                </small>
              </div>
            </Stack>
          </Col>
        </Row>
        <Divider my={3} variant={"dashed"} />
      </Box>
    );
  };

  return (
    <Box mb={3}>
      <Row>
        <Col breakPoint={{ sm: isBigScreen ? 2 : 1 }}>
          <Flex align="center">
            {showIcon && (
              <Icon as={isSwimming ? FaSwimmer : IoTennisball} mr={2} />
            )}
            {isBigScreen && sport}
          </Flex>
        </Col>
        <Col breakPoint={{ sm: 2 }} className="elipsis">
          {type}
        </Col>
        <Col breakPoint={{ sm: isBigScreen ? 4 : 5 }}>
          {location}
          {!isBigScreen && <br />}
          {bundle ? BundleDetails(bundle) : null}
          {name ? (
            <Text as="i" color={"gray.500"}>
              ({name})
            </Text>
          ) : null}
        </Col>
        <Col breakPoint={{ sm: 2 }}>{periodName}</Col>
        <Col breakPoint={{ sm: 2 }} style={{ textAlign: "right" }}>
          {price}&nbsp;zł
        </Col>
      </Row>
      {setItemConsent && isEditable && <AdditionalInfo />}
    </Box>
  );
};
